module.exports = __webpack_public_path__ + "static/media/autoThreeWheel.8987e81b.svg";